import { clinic } from "../data/mock";

export const getWhatsAppLink = (message) => {
  const text = message || "Hello Dr. Indresh Dixit, I would like to book a consultation for a liver check-up.";
  return `https://wa.me/${clinic.whatsapp}?text=${encodeURIComponent(text)}`;
};
